import React from "react";
import { Header } from "semantic-ui-react";

// AI meeting notes as the templates settings preview shows them.
//
// Each note has an optional header and a content array. How it renders:
//  - Headerless notes are treated as prose (this is what "brief paragraph" style
//    instructions produce). The model tends to return prose as several sentence
//    strings, so they're joined into one flowing paragraph.
//  - A note with a header and a single content line also reads better as a
//    paragraph than a lone bullet.
//  - Anything else (a header with multiple lines) renders as bullet points.
// `headerStyle` lets a compact surface (the settings preview) shrink headers.
export function MeetingNotesList({ sections, headerStyle }) {
  if (!sections || sections.length === 0) {
    return null;
  }

  return (
    <>
      {sections.map((section, idx) => {
        const hasHeader = Boolean(section.header);
        const content = (section.content ?? []).filter(Boolean);

        if (!hasHeader && content.length === 0) {
          return null;
        }

        const asParagraph = !hasHeader || content.length <= 1;

        return (
          <React.Fragment key={idx}>
            {hasHeader ? (
              <Header as="h3" style={headerStyle}>
                {section.header}
              </Header>
            ) : null}
            {content.length === 0 ? null : asParagraph ? (
              <p>{content.join(" ")}</p>
            ) : (
              <ul>
                {content.map((line) => (
                  <li key={line}>{line}</li>
                ))}
              </ul>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}
